export const buildGradient = (colors: string[], direction: string) =>
  `linear-gradient(${direction}, ${colors.join(', ')})`;
